@if (employee$ | async; as employee) {
  <app-detail-view [data]="employee" (closeClicked)="onCloseButtonClicked()">
    <hoc-person-card [details]="employee" />
    <gx-tabs>
      <gx-tab caption="{{ 'profile.singular' | translate }}" id="profile">
        <app-employee-profile
          [employee]="employee"
          [highlightedSkill]="highlightedSkill"
          (companySelected)="companySelect($event)"
          (locationSelected)="locationSelect($event)"
          (boardSelected)="boardSelect($event)"></app-employee-profile>
      </gx-tab>
      <gx-tab caption="{{ 'skill.plural' | translate }}" id="skills">
        <app-employee-skills [employee]="employee" [highlightedSkill]="highlightedSkill"></app-employee-skills>
      </gx-tab>
      <gx-tab caption="{{ 'project.plural' | translate }}" id="projects">
        <app-employee-projects [employee]="employee" [isAdmin]="isAdmin"></app-employee-projects>
      </gx-tab>
    </gx-tabs>
  </app-detail-view>
} @else {
  <ng-template #placeholder>
    <app-employee-details-placeholder (closeClicked)="onCloseButtonClicked()"/>
  </ng-template>
}
